import { findNearestWindowWithCopilotChannel } from '../utils/findNearestWindowWithCopilotChannel';
import CopilotChannel from './CopilotChannel';
export const createCopilotChannel = options => {
  const topWindow = options && options.createLayer ? window : findNearestWindowWithCopilotChannel(window);
  if (!topWindow.copilotChannel) {
    topWindow.copilotChannel = new CopilotChannel(options);
  }
  return topWindow.copilotChannel;
};